import React, {Component} from "react";
import { withRouter } from 'react-router';
import { callPOST, callGET } from '../../Utils/ApiUtil';
import { connect } from 'react-redux';
import Buttons from "../../Components/UI/Buttons";
import http from '../../services/http';

// import Modal from '../../Components/UI/Modal';
import Modal from "react-bootstrap/Modal";
import {getActivityReminderDetails} from "../../Utils/UserFunctions";
import {getSelectedValueFromForm,field_filter,rulesChecking,convertContitionsJSONvalues, convertStrToArrWithSeparator} from "../../Utils/CommonFunctions";
// import Wrp from '../../hoc/Wrp/Wrp';
import FormContentData from './LayoutForms/FormContentData';
import { isSet,isObject } from "../../Utils/CommonFunctions";
import './custom.css';
// import map from "lodash/map";
import {
  setLayoutDataActions,
  onChangeInputAction,
  addFormFieldValidationAction,
  clearFormFieldValidationAction,
  updateFormFieldValidationAction,
  addSelectedMultiLookupAction,
  removeSelectedMultiLookupAction,
  clearSelectedMultiLookupAction,
  setSelectedMultiLookupAction,
  setLayoutRulesAction,
  setValidationRulesAction,
  setSubFormDataAction,
  setOnChangeConfigDataQCAction,
  setOnChangeConfigVariableListQCAction,
  onBlurHandlerAction
} from "../../store/actions/formBuilderActions";
import {
  setErrorListAction,
  clearErrorListAction,
  showErrorDetailsAction,
} from '../../store/actions/ErrorSetupAction';
import { variableDetailsLookupFromList } from "./LayoutCommonFunction";

class QuickCreateForms extends Component{
    constructor(props) {
      super(props);
      this.state = {
        isQuickAddModalOpen:this.props.isQuickAddModalOpen,
        DVauditLog:{}
      };
    }
    componentDidUpdate = (prevProps) => {
      if(prevProps.isQuickAddModalOpen !== this.props.isQuickAddModalOpen) {
        this.setState({isQuickAddModalOpen: this.props.isQuickAddModalOpen});
        if(this.props.isQuickAddModalOpen===true){

        }
      }
    }
    componentWillMount = () =>{
      const params = this.props.match.params;
      const lookup_layout = this.props.lookup_layout;
      this.props.Loader();
      let API_Url ="layouts/"+lookup_layout.lookupLayoutId+'/add_form/'+false;
      //if(params.layoutId!=undefined){
        this.props.setSubFormDataAction('QUICKFORM',[]);
        this.props.setLayoutDataActions('QUICKFORM',{
          layout_name:"",
          module_id: "",
          window_id: "",
          master_detail_windows:null,
        },[],[]); 
        this.props.clearFormFieldValidationAction('QUICKFORM');
        this.props.setLayoutRulesAction('QUICKFORM',{});
        this.props.setValidationRulesAction('QUICKFORM',{});
        // this.props.clearSelectedMultiLookup();
        this.fetchOnChangeDetails();
        callGET(API_Url)
        .then(res => {
          if(res.status===200){ 
            // this.fieldValidationRules();
            this.layoutValidationRules();
            this.props.Loader();
            const response = res.data;
            console.log(response);
            if(response.code===200){
              const responseData = response.data;
              console.log(responseData);
                //Rearrange itemIndex if anything missed from backend
                responseData.fieldGroups.map((fields,index)=>{
                  fields.section_index=index;
                  // fields.quickCreateForm=true;
                    return fields.data.map((field,i)=>{
                        if(field.element!=='Date' && field.element!=='DateTime'){
                          field.selectedValue = (field.default_value && field.default_value!==null)?field.default_value:(field.selectedValue && field.selectedValue!=='')?field.selectedValue:null;
                        }
                        field.reminder = null;
                        field.itemIndex = i;
                        return field;
                    })
                })
                this.props.setLayoutDataActions('QUICKFORM',{
                  id:responseData.id,
                  layout_name:responseData.layout_name,
                  module_id: responseData.module_id,
                  window_id: responseData.window_id,
                  master_detail_windows:responseData.master_detail_windows,
                },
                responseData.fieldGroups,responseData.nonFieldGroups);
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.props.Loader();
        })
      // }else{
        
      // }
      
    }
    onBlurFormsActionHandler = (updateData,e,inputType='text')=>{
      //onBlurHandlerAction
      const  onChangeDataConfig = this.props.onChangeDataConfig;
      // console.log('loggerr',updateData,e,inputType);
      let fieldValue;
    if(inputType==='PickList'){
      fieldValue = e;
    }else if(inputType==='CheckBoxes'){
      fieldValue = e.target.checked;
    }else if(inputType==='MultiSelect'){
      let MultiSelectValue = [];
      e = (e===null)?[]:e;
      e.map((item)=>{
        MultiSelectValue.push(item.id);
        return item;
      }); 
      fieldValue = MultiSelectValue.join(',');
    }else if(inputType==='Lookup'){
      fieldValue = e;
    }else if(inputType==='number'){
      fieldValue = e; 
    }else if(inputType==='MultiLookup'){
      fieldValue = e; 
    }else if(inputType==='date'){
      fieldValue = e;
    }else if(inputType==='Files'){
      fieldValue = e;
    }else if(inputType==='Reminder'){
      fieldValue = e;
    }else if(inputType==='currencyType'){
      fieldValue = e;
    }else if(inputType==='exchangeRate'){
      fieldValue = e;
    }else if(inputType==='phoneNumber'){
      fieldValue = e;
    }else if(inputType==='CustomAllSingle'){
      fieldValue = e;
    }else if(inputType==='CustomAllArray'){
      let MultiArrayValue = [];
      e = (e===null)?[]:e;
      e.map((item)=>{
        MultiArrayValue.push(item.id);
        return item;
      }); 
      fieldValue = MultiArrayValue.join(',');
    }else if(e){
      try{
        fieldValue = e.target.value;
      }catch(e){
  
      }
    }
    const payload = { 
        fieldObj:updateData,
        value:fieldValue,
        inputType:inputType
      }
      // console.log('onChangeDataConfig',onChangeDataConfig);
      const payloadFieldObj = payload.fieldObj;
        // payloadFieldObj.item.id otherObj={}
        // console.log('payloadFieldObj',payloadFieldObj);
        const isExistIndex = onChangeDataConfig.findIndex(i=>i.field_id===payloadFieldObj.item.id);
        // console.log('P0J1P0',isExistIndex);
        if(isExistIndex!==-1){
          const changeHandlerData = onChangeDataConfig[isExistIndex];
          if(changeHandlerData.config_type==="STEPS"){
            let formData = {
              ...this.props.layoutObject,
              subformData:this.props.subformData,
              fieldGroups:this.props.fieldGroups,
              nonFieldGroups:this.props.nonFieldGroups
          }
  
              const stepsId = changeHandlerData.config_id;
              // console.log('changeHandlerData',changeHandlerData);
              let requestVariableValues = [];
              changeHandlerData.field_mapping.forEach((field)=>{
                const conditionField = getSelectedValueFromForm(formData,{
                  searchBy:'id',id:field.tableDescriptorId,
                  fieldData:field,
                });
               
                requestVariableValues.push({
                  "variable_id": field.variableId,
                  "variable_name": field.variableName,
                  "tabledescriptor_id":field.tableDescriptorId,
                  "values": [
                    {
                      "value": (conditionField.isExist===true)?conditionField.selectedValue:''
                    }
                  ]
                })
              });
              // console.log('requestVariableValues',isSet(fieldValue,null));
              if(isSet(fieldValue,null)===null){
                return false;
              }
              // console.log('stepsId,requestVariableValues,changeHandlerData,formData',stepsId,requestVariableValues,changeHandlerData,formData);
              this.excecuteHandler(stepsId,requestVariableValues,changeHandlerData,formData);
            
          }
          // console.log('onChangeDataConfigisExistIndex',onChangeDataConfig[isExistIndex]);
        }
    }
    excecuteHandler = (processId,inputValuesPayload,changeHandlerData,formData) => {
      this.props.Loader(true);
      let ApiMethod = http.POST;
      let ApiURL = '/steps/'+processId+'/execute-step/direct';
      if(inputValuesPayload.length>0){
         ApiMethod = http.POST; 
         ApiURL = '/steps/'+processId+'/execute-step/direct';
      }
      ApiMethod(ApiURL,inputValuesPayload)
        .then(response => {
          this.props.Loader(false);
        const responseData = response.data;
        // console.log(responseData);
        // console.log('responseData',responseData.data);
        if(responseData.code === 200) {
          const resData = responseData.data;
          // responseData.variables
          let assignedValueArr = [];
          // const startTime = performance.now();
          const {onChangeDataConfigVariables} = this.props;
          const variables = isSet(onChangeDataConfigVariables[changeHandlerData.config_id],[]);
          
          changeHandlerData.field_mapping.forEach((field)=>{
            let splitedWindow = convertStrToArrWithSeparator(isSet(field.absolute_window,''),'.');
            splitedWindow.push(field.tableDescriptorId);
          
            
            // console.log('assignedVariable',assignedVariable);
            if(field.is_response===true){
              // console.log('field.tableDescriptorId',field.tableDescriptorId);
                let conditionField = {type:'FIELD',...getSelectedValueFromForm(formData,{
                searchBy:'id',id:field.variableId,
                fieldData:field,
              })};
              if(conditionField.isExist===false){
                conditionField = {type:'SECTION',...getSelectedValueFromForm(formData,{
                  searchBy:'sectionId',id:field.variableId,
                  fieldData:field,
                })};
              }
              const resDataVariables = resData.variables; 
              
              const isAbsoluteExist = resDataVariables.findIndex(i => splitedWindow.indexOf(i.id) !== -1);
              const isExist         = resDataVariables.findIndex(i => [field.tableDescriptorId].indexOf(i.id) !== -1);
              const msgIndexing     = resDataVariables.findIndex(i => isSet(i.api_name,'')==="messages");
  
              
              if(msgIndexing!==-1){
                try{
                  let errorsList =  isSet(resDataVariables[msgIndexing].value,[]);
                  if(errorsList.length>0){
                    this.props.setErrorListAction(errorsList);
                    if(!this.props.isErrorModalOpen){
                      this.props.showErrorDetailsAction();
                    }
                  }
                }catch(e){
  
                }
              }
                if(isExist!==-1){
  
                  // console.log('resDataVariables',resDataVariables[isExist].value,assignedVariable);
  
                  try{
                    let responseVariable = '';
                    try{
                      responseVariable = JSON.parse(resDataVariables[isExist].value);
                    }catch(e){
                      // console.log('exception...',e);
                    }
                    const assignedValue    = responseVariable;
                    // if(!isObject(assignedValue)){
  
                    // }
                    // console.log('assignedValue',conditionField,assignedValue);
                    assignedValueArr.push({
                      key:{...conditionField,modType:this.props.modType},
                      value:assignedValue
                    });
                    // this.props.onBlurHandlerAction({...conditionField,modType:this.props.modType},assignedValue);
                    
                  }catch(e){
                    
                  }
                  
                }
              else if(isAbsoluteExist!==-1){
                const assignedVariable = variableDetailsLookupFromList(variables,isSet(field.absolute_window,field.tableDescriptorId));
                try{ 
                  let responseVariable = {};
                  try{
                    responseVariable = JSON.parse(isSet(resDataVariables[isAbsoluteExist].value,''))
                    // console.log('responseVariable',responseVariable);
                  }catch(e){
  
                  };
                  if(conditionField.isExist===true){
                    // const fieldAPIname = (conditionField.type==='FIELD')?conditionField.field.api_custom_field_name:conditionField.section.title.toString().toLowerCase();
                    const fieldAPIname = assignedVariable.api_name;
                    if(isSet(fieldAPIname,null)===null){
                      return false;
                    }
                    let assignedValue = isSet(responseVariable[fieldAPIname],'');
                    // console.log('assignedValue lookup',conditionField,assignedValue);
                    if(conditionField.type==='FIELD' && conditionField.field.element==='PickList'){
                      if(isSet(conditionField.field.picklist_type,'NONE')==='NONE'){
                        const picklistIndex = conditionField.field.options.findIndex(i=>i.value===isSet(assignedValue.value,''));
                        if(picklistIndex!==-1){
                          assignedValue = conditionField.field.options[picklistIndex].id;
                        }
                      }else{
                        assignedValue = isSet(assignedValue.value,'')
                      }
                     
                     
                      // console.log('condition...',picklistIndex);
                    }
                    if(conditionField.type==='FIELD' && conditionField.field.element==='Lookup'){
                      
                      let lookupValue = [];
                      let lookupAllValue = [];
                      for (let key in assignedValue) {
                        if(key.indexOf('name')!==-1 && !isObject(assignedValue[key]) && lookupAllValue.length<1){
                          lookupAllValue.push(assignedValue[key]);
                        }
                        if(key!=='id' && key.indexOf('_name')!==-1 && !isObject(assignedValue[key]) && lookupAllValue.length<1){
                          lookupValue.push(assignedValue[key]);
                        }
                      }
                      assignedValue = JSON.stringify({
                        id:assignedValue.id,
                        dpnm:lookupValue.length===0?lookupAllValue.join(', '):lookupValue.join('')
                      });
                    }
                    if(conditionField.type==='FIELD' && conditionField.field.element==='MultiLookup'){
                      // console.log('conditionField',conditionField,assignedValue);
                      let multilookupValues = isSet(assignedValue,[]).map((itm,itmIndex)=>{
                        return{
                          ...itm,
                          // id:itm.id,
                          meta_table_id:itm.id,
                          fieldGroups:[{id:itmIndex,data:[{label:{blocks:[{text:'Name'}]},id:itmIndex,element:"TextInput",selectedValue:itm.name}]}]
                        }
                      });
                      assignedValue = JSON.stringify(multilookupValues);
                      // console.log('conditionField',fieldAPIname,assignedValue,multilookupValues);
                      // fieldGroups
                    }
  
                    if(conditionField.type==='SECTION' && conditionField.section.type==='subform'){
                        // console.log('assignedValue- subform');
                        // console.log('conditionField',conditionField);
                        // console.log('assignedValue-itm',assignedValue);
                        let subformDataInArr = assignedValue.map((itm,itmIndex)=>{
                          
                          
                          return{
                            id:itm.id,
                            display_postition:itmIndex,
                            subform_column_values:conditionField.section.data.map((col)=>{
                              let selectedValue = isSet(itm[col.api_custom_field_name],'');
                              if(col.element==='Lookup'){
                                let lookupValue = [];
                                let lookupAllValue = [];
                                for (let key in selectedValue) {
                                  if(key.indexOf('name')!==-1 && !isObject(selectedValue[key]) && lookupAllValue.length<1){
                                    lookupAllValue.push(selectedValue[key]);
                                  }
                                  if(key!=='id' && key.indexOf('_name')!==-1 && !isObject(selectedValue[key]) && lookupAllValue.length<1){
                                    lookupValue.push(selectedValue[key]);
                                  }
                                }
                                selectedValue = selectedValue.id;
                                //lookupValue.length===0?lookupAllValue.join(', '):lookupValue.join('');
                                // JSON.stringify({
                                //   id:selectedValue.id,
                                //   dpnm:lookupValue.length===0?lookupAllValue.join(', '):lookupValue.join('')
                                // });
                                
                                // console.log('selectedValue',selectedValue);
                              }
                              if(col.element==='PickList'){
                                // const picklistIndex = col.options.findIndex(i=>i.value===isSet(isSet(selectedValue.value,'')));
                                // if(picklistIndex!==-1){
                                //   selectedValue = col.options[picklistIndex].id;
                                // }
                                if(isSet(col.picklist_type,'NONE')==='NONE'){
                                  const picklistIndex = col.options.findIndex(i=>i.value===isSet(isSet(selectedValue.value,'')));
                                  if(picklistIndex!==-1){
                                    selectedValue = col.options[picklistIndex].id;
                                  }
                                }else{
                                  assignedValue = isSet(selectedValue.value,'');
                                }
                                
                              }
                              if(col.element==="Decimal"){
                                selectedValue = isSet(selectedValue,0).toFixed(2);
                              }
                              // if(col.api_custom_field_name==="cf_package_tracking_number"){
                              //   selectedValue = '';
                              // }
                              
                              // console.log('selectedValue',col,selectedValue);
                                
                          
                              
                              return {
                                display_name:isSet(col.label.blocks[0].text,col.api_custom_field_name),
                                selected_value:selectedValue,
                                selected_value_text:'',
                                table_descriptor_id:col.id,
                              }
                            })
                            
                          }
                        });
                        assignedValue = [{
                          field_group_id:'',
                          field_group_name:conditionField.section.title,
                          field_group_section_id:conditionField.section.id,
                          subform_rows:subformDataInArr
                        }];
                    }
                    // console.log('assignedValue',assignedValue);
                    // console.log('responseVariable',responseVariable,'==',assignedValue,'_',fieldAPIname);
                    assignedValueArr.push({
                      key:{...conditionField,modType:this.props.modType},
                      value:assignedValue
                    });
                    // this.props.onBlurHandlerAction({...conditionField,modType:this.props.modType},assignedValue);
                   
                  }
                }catch(e){
                  // console.log('assignedValue e',e);
                  if(conditionField.isExist===true){
                    let selectedVal = '';
                    if(conditionField.type==='SECTION' && conditionField.section.type==='subform'){
                      selectedVal = [];
                    }
                    assignedValueArr.push({
                      key:{...conditionField,modType:this.props.modType},
                      value:selectedVal
                    });
                    // this.props.onBlurHandlerAction({...conditionField,modType:this.props.modType},selectedVal);
                  }
                }
              }
            }
          });
          // console.log('assignedValueArr',assignedValueArr);
          this.props.onBlurHandlerAction({valuesInArr:assignedValueArr,modType:this.props.modType,isBulk:true},'');
          // const endTime = performance.now();
          // const timeTaken = endTime - startTime;
          // console.log(`Execution Time: ${timeTaken} milliseconds`);
  
  
  
          // this.getExecuteResults(inputValuesPayload,responseData.data.id,0);
          // this.setState({
        // 	// executeResultModel:true,
        // 	executeResults:responseData.data.execution_log
          // })
          // let errorsList = []; //responseData.messages;
          // if(isSet(responseData.messages,[]).length>0){
          // 	errorsList = responseData.messages;
          // 	this.props.setErrorListAction(errorsList);
          // }			  
        }else {
         
          this.props.Loader(false);
        }
        
        })
        .catch(err => {
          this.props.Loader(false);
          console.log("error occured",err);
        });
      }
    fetchOnChangeDetails = ()=>{
      // const params = this.props.match.params; 
      const lookup_layout = this.props.lookup_layout;
      // console.log('lookup_layout',lookup_layout);   
      http.GET(`onchange-handler/view/${lookup_layout.windowId}/${lookup_layout.lookupLayoutId}/ONCHANGE`)
      .then(res => {
        if(isSet(res.status,null)!==null && res.status===200){ 
        //   this.props.Loader();
          const response = res.data;
          if(response.code===200){
            const responseData = response.data;
            this.props.setOnChangeConfigDataQCAction(isSet(responseData.window_fields,[]));
            isSet(responseData.window_fields,[]).forEach((i)=>{
              this.fetchVariablesList(i.config_type,i.config_id);
            })
          }else{
          }
        }
      })
      .catch(err => {
      //   console.log(err);
      //   console.log('this.props',this.props);
      //   this.props.Loader();
      //   this.props.failMessage('Something went wrong..')
      })
      
    }

    fetchVariablesList = (functionType,configId,callBack,index=0) => {
      const queryStringNew = '?functionType='+functionType+'&referenceId='+configId;
      http.GET("variable/search"+queryStringNew)
      .then(async (response) => {
        const responseData = response.data;
        if(responseData.code === 200) {
          const data = responseData.data;
          this.props.setOnChangeConfigVariableListQCAction({configId:configId,data:data});
        }
      },(error) => {
        console.log(error);
      })
    }
    layoutValidationRules = ()=>{
      const lookup_layout = this.props.lookup_layout;
      const API_Url = 'layout-rule/list/'+lookup_layout.windowId+'/'+lookup_layout.lookupLayoutId;
      callGET(API_Url)
        .then(res => {
          if(res.status===200){ 
            // this.props.Loader();
            const response = res.data;
            // console.log(response);
            if(response.code===200){
              const responseData = response.data;
              // console.log(JSON.stringify(responseData.content));
              // responseData.content
              // const conditions =  responseData.conditions;
              // const fieldId =  responseData.table_descriptor_id;
              this.props.setLayoutRulesAction('QUICKFORM',responseData.content);
              setTimeout(() => {
                this.props.onChangeInputAction({
                  section_index:0,
                  itemIndex:0,
                  item:{modType:'QUICKFORM'},
                },'','reload');
              }, 200);
            }
          }
        })
        .catch(err => {
          console.log(err);
          //this.props.Loader();
        })
    }
    onSubmitQuickCreateForm = (wthis,is_preverification=false) =>{
      const params = this.props.match.params; 
      let postData = {
        ...this.props.layoutObject,
        subform_data:this.props.subformData,
        fieldGroups:this.props.fieldGroups,
        nonFieldGroups:this.props.nonFieldGroups,
      }
      this.props.Loader();
      postData = JSON.parse(JSON.stringify(postData));
      // console.log(JSON.stringify(postData));
      let API_Url ='table-data-engine/'+this.props.lookup_layout.windowName+'/create';
         callPOST(API_Url,postData)
          .then((res) => {
            if(res.status===200){ 
              this.props.Loader();
              const response = res.data;
              // let validationErrorCount = this.frontEndFormsValidation();
              if(response.code===200){

                // if(is_preverification===false){
                  if(this.props.lookup_layout.windowName==='Activities'){
                    getActivityReminderDetails();
                  }
                  this.props.succMessage((res.data.message)?res.data.message:''+params.windowName+' created successfully');
                  // this.props.history.push("/layouts/"+params.windowName+"/"+params.windowId+"/list/"+params.layoutId);
                  this.props.closeQuickCreatePopup();
                  this.props.goBackLookupList();
                // }else if(validationErrorCount==0){
                //   this.onSubmitQuickCreateForm(wthis,false);
                // }
              }else if(response.code===400){
                const violations = response.violations;
                violations.map((fields)=>{
                  this.props.updateFormFieldValidationAction('QUICKFORM',fields.field_id,fields.message)
                })
                if(violations.length===0){
                  this.props.failMessage(response.message);
                }
              }else{
                this.props.failMessage("Something went wrong while saving "+params.windowName+"");
              }
            }
            
          }, (error) => {
            this.props.Loader();
            this.props.failMessage("Something went wrong while saving "+params.windowName+"");
            console.log(error);
          });
    
    }
    getSelectedValueFromForm = (object)=>{
      const searchBy = object.searchBy;
      // console.log(object);
      let conditionField = {};
        const fieldGroups = [...this.props.fieldGroups];
        fieldGroups.map((section)=>{
          section.data.map((field)=>{
            // console.log(field.id,object.id,field.label.blocks[0].text);
            if(searchBy==='name' && field.label.blocks[0].text===object.fieldName){
              conditionField = {
                field:field,
                selectedValue:field.selectedValue,
                isExist:true
              }
            }else if(searchBy==='id' && field.id===object.id){
              conditionField = {
                field:field,
                selectedValue:field.selectedValue,
                isExist:true
              }
            }
          })
        })
        return conditionField;
    }
    validateRulesValidations = ()=>{
      let errorCount = 0;
      this.props.clearFormFieldValidationAction();
      let updatedPreviewItems = this.props.fieldGroups;
      // console.log(this.props.validationRules);
      if(this.props.validationRules!==undefined)
      Object.entries(this.props.validationRules).map(([key, field]) => {
        let validationResult = '';
        if(field.is_active===true && field.conditions!==null && field.conditions!==undefined){
          field.conditions.map((cond,condIndex)=>{
            const conditionField = getSelectedValueFromForm(updatedPreviewItems,{
              searchBy:'name',fieldName:field.display_name
            });
            if(conditionField.isExist===true){
              validationResult = rulesChecking({
                filter:field_filter[(cond.field_filter).split(' ').join('_')],
                selectedValue:conditionField.selectedValue,
                field:conditionField.field,
                value:convertContitionsJSONvalues({
                  values:cond.values,
                  field_filter:cond.field_filter,
                })
              });
            }
            let conditionValidationResult = validationResult;
            // console.log(conditionField,field.display_name);
            const sub_conditions  = (cond.sub_conditions)?cond.sub_conditions:[];
            sub_conditions.map((subCond)=>{
              validationResult = conditionValidationResult;
              validationResult='(true==='+validationResult+')';
              if(subCond.condition_json.length>0){
                validationResult+=' && (';
              }
              let alertMessage = subCond.alert_message;
              subCond.condition_json.map((condJson)=>{
                if(condJson==='and'){
                  validationResult+=' &&';
                }else if(condJson==='or'){
                  validationResult+=' || ';
                }else{
                    const conditionField = getSelectedValueFromForm(updatedPreviewItems,{
                      searchBy:'name',fieldName:condJson.field_label
                    });
                    if(condJson.field_label===undefined || condJson.field_label===''){
                      validationResult+='(true===false)';
                    }else
                    if(conditionField.isExist===true){
                      validationResult+=' (true==='+rulesChecking({
                        filter:field_filter[(condJson.comparator).split(' ').join('_')], 
                        selectedValue:conditionField.selectedValue,
                        field:conditionField.field,
                        value:convertContitionsJSONvalues({
                          values:condJson.values,
                          field_filter:condJson.comparator,
                        })
                      })+' )';
                      // console.log(validationResult,condJson.values);
                    }
                }
              })
              if(subCond.condition_json.length>0){
                validationResult+=')';
                if(eval("("+validationResult+")")){
                  errorCount++;
                  this.props.updateFormFieldValidationAction('QUICKFORM',conditionField.field.id,alertMessage);
                  // this.props.failMessage(alertMessage);
                }
              }else{
                if(eval("("+validationResult+")")){
                  errorCount++;
                  this.props.updateFormFieldValidationAction('QUICKFORM',conditionField.field.id,alertMessage);
                }
              }
              // console.log(validationResult);
            })
          })
        }
      })
      return errorCount;
    }
    frontEndFormsValidation = ()=>{
      let validationCount = 0;
      validationCount = this.validateRulesValidations();
      this.props.fieldGroups.map((fields)=>{
        return fields.data.map((field,i)=>{
          if(field.required===true && (field.selectedValue==='' || field.selectedValue===null)){  
            this.props.updateFormFieldValidationAction('QUICKFORM',field.id,field.label.blocks[0].text+' field must be required');
            validationCount++;
          }
        })
      });
      return validationCount;
    }
    render(){
      const params = this.props.match.params;
      const ModalTitle = 'Quick Create';
      const quickCreateButtonList = [
        {
            attributes:{
              className:"btn border-default btn-border mr-2 cursor-pointer",
            },
            clickHandler:this.props.closeQuickCreatePopup,
            name:"Cancel"
          },  
        {
          attributes:{
            className:"btn primary_bg cursor-pointer"
          },
          clickHandler:this.onSubmitQuickCreateForm,
          name:"Save"
        }]
          
        const modalTitle =  <h5 className="modal-title secondary_color" id="staticModalLabel">
                              {ModalTitle}&nbsp;-&nbsp; 
                              <span className="badge badge-info">
                                {this.props.lookup_layout.windowName}
                              </span>
                            </h5>;
                          
        return (
          <>
          <Modal style={{ zIndex: 1055 }}  // Set zIndex for the Modal
                  backdropClassName="custom-backdrop"   show={this.state.isQuickAddModalOpen} size="xl" onHide={this.props.closeQuickCreatePopup}>
	        <Modal.Header>
            {modalTitle}
	        </Modal.Header>
	      <Modal.Body>
          <div className="row">
            <FormContentData 
                  modType={this.props.modType} 
                  isQuickCreate={true}
                  onBlurHandlerAction={this.onBlurFormsActionHandler}
                  onChangeInputAction={this.props.onChangeInputAction}
                  validationForms={this.props.validationForms} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Buttons buttonList={quickCreateButtonList} />
        </Modal.Footer>
	    </Modal>

       {/* <Modal
            isModalOpen={this.state.isQuickAddModalOpen}
            modalDim={'modal-xl'}
            title={modalTitle}
            buttonList={quickCreateButtonList}>
              <FormContentData 
                  modType={this.props.modType} 
                  isQuickCreate={true}
                  onChangeInputAction={this.props.onChangeInputAction}
                  validationForms={this.props.validationForms} />
              </Modal> */}
          </>
          
            
          
          );
    }
}


QuickCreateForms.defaultProps = {
  isPopupWindow: false,
  isMasterWindow:false,
  isActivityWindow:false,
  windowDetails:{},
  modType:'QUICKFORM'
}

export default
  connect(
    (state) => ({
      fieldGroups : state.formBuilder.fieldGroups['QUICKFORM'],
      layoutObject:state.formBuilder.layoutObject['QUICKFORM'],
      validationForms:state.formBuilder.validationForms['QUICKFORM'],
      nonFieldGroups : state.formBuilder.nonFieldGroups['QUICKFORM'],
      validationRules:state.formBuilder.validationRules['QUICKFORM'],
      subformData:state.formBuilder.subformData['QUICKFORM'],
      onChangeDataConfig:state.formBuilder.onChangeDataConfigQC,
      onChangeDataConfigVariables:state.formBuilder.onChangeDataConfigVariablesQC,

    }), 
    { 
      setLayoutDataActions,
      onChangeInputAction,
      addFormFieldValidationAction,
      clearFormFieldValidationAction,
      updateFormFieldValidationAction,
      addSelectedMultiLookupAction,
      removeSelectedMultiLookupAction,
      clearSelectedMultiLookupAction,
      setSelectedMultiLookupAction,
      setLayoutRulesAction,
      setSubFormDataAction,
      setValidationRulesAction,
      setOnChangeConfigDataQCAction,
      setOnChangeConfigVariableListQCAction,
      setErrorListAction,
      clearErrorListAction,
      showErrorDetailsAction,
      onBlurHandlerAction
    }
  )(withRouter(QuickCreateForms));